import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { useGlobalState } from './stateProvider/StateProvider';
import { QuestRoute } from './api/QuestRoutes';
import HamQuest from './api/HamQuestGiver';
import Loading from './Loading';
import Col from './layout/Col';
import Form from './forms/Form';
import Input from './forms/Input';
import Row from './layout/Row';
import Select from './forms/Select';
import { generateId, getMonths } from './utility/functions';
import ModalFactory from './Modal';

const PaymentForm = ({ socketId, amount, userId, ...props }) => {
    const {
        state: {
            active_user
        },
    } = useGlobalState();

    const [formData, setFormData] = useState(null);
    const [processor, setProcessor] = useState(null);

    useEffect(() => {
        // if (process.env.REACT_APP_ENV !== 'prod') {
        //     dummyRequest()
        //         .then(() => setProcessor('demo'))
        //     return;
        // }

        HamQuest.getQuery(QuestRoute.user.processor(userId), {
            socketId: socketId,
        })
            .then(res => {
                setProcessor(res.processor)
                setFormData({ userId, ...res.setupData })
            })
            .catch(ModalFactory.catch)
    }, [])

    if (!active_user.isLoggedIn) return;
    if (!processor) return <Col align='center'><Loading /></Col>;

    switch (processor.toLowerCase()) {
        case 'exact':
            return <div>Please set up Exact Hosted.</div>
        case 'exacthosted':
            return <ExactForm formData={formData} />
        case 'worldpay':
            return <WorldPayForm formData={formData} />
        case 'ips':
            return <IPSForm formData={formData} />
        case 'moneris':
            return <MonerisForm formData={formData} socketId={socketId} />
        case 'moneris_deprecated':
            return <MonerisDeprecated formData={formData} socketId={socketId} />
        case 'demo':
            return <DemoForm />
        default:
            return <div>No payment Processor!</div>
    }
}

export default PaymentForm;

// DEMO ///////////////////////////////////////////////////////////////////////////////////////////////////////
const Demo = styled.iframe`
    height: 450px;
    min-width: 340px;
    width: 100%;
    border: 0px;
    background: ${({ theme }) => theme.white};
    border-radius: 0.2rem;
    font-size: 0.9em;
    overflow: hidden;
`;
const DemoForm = ({ formData, ...props }) => {
    const months = getMonths();
    return (
        <Form
            inputs={{
                cardNumber: '',
                expMonth: '',
                expYear: '',
                CVV: '',
            }}
            text='Tokenize Card'
        >
            <Input
                label='Card Number'
                name='cardNumber'
                type='number'
                required
            />
            <Row wrap>
                <Select
                    label='Exp. Month'
                    name='expMonth'
                    options={months}
                    required
                />
                <Select
                    label='Exp. Year'
                    name='expYear'
                    options={Array.from({ length: 15 }, (_, i) => {
                        const val = new Date().getFullYear() + i;
                        return { label: val, value: val };
                    })}
                    required
                />
            </Row>
            <Input
                label='CVV'
                name='CVV'
                type='number'
                required
            />
        </Form>
    )
};

// IPS ///////////////////////////////////////////////////////////////////////////////////////////////////////
const IPS = styled.iframe`
    height: 510px;
    min-width: 500px;
    width: 100%;
    border: 0px;
    background: ${({ theme }) => theme.white};
    border-radius: 0.2rem;
    font-size: 0.9em;
    overflow: hidden;
`;
export const IPSForm = ({ formData, ...props }) => {
    return (<IPS src={formData?.form_url} />)
};

// WORLDPAY ///////////////////////////////////////////////////////////////////////////////////////////////////////
const WorldPay = styled.iframe`
    height: 450px;
    min-width: 340px;
    width: 100%;
    border: 0px;
    background: ${({ theme }) => theme.white};
    border-radius: 0.2rem;
    font-size: 0.9em;
    overflow: hidden;
`;
const Tag = styled.span`
    font-size: 0.5em;
    line-height: 1.2em;
`;
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
export const WorldPayForm = ({ formData, ...props }) => {
    return (<WorldPay src={formData?.form_url} />)
};

// EXACT ///////////////////////////////////////////////////////////////////////////////////////////////////////
const Exact = styled.form`
    display: flex;
    flex-grow: 1;
    height: 420px;
    background: ${({ theme }) => theme.white};
`
export const ExactForm = ({ formData, ...props }) => {
    useEffect(() => {
        if (!formData) return;
        document.getElementById('exactHostedForm').submit()
    }, [formData])

    return (
        <Exact action='https://checkout.e-xact.com/pay' method="post" target="ExactEmbeddedFrame" id="exactHostedForm">
            <input name="x_login" value={formData?.x_login} type="hidden" />
            <input name="x_amount" value={formData?.x_amount} type="hidden" />
            <input name="x_fp_sequence" value={formData?.x_fp_sequence} type="hidden" />
            <input name="x_fp_timestamp" value={formData?.x_fp_timestamp} type="hidden" />
            <input name="x_fp_hash" value={formData?.x_fp_hash} type="hidden" />
            <input name="x_currency_code" value={formData?.x_currency_code} type="hidden" />
            <input name="x_show_form" value="PAYMENT_FORM" type="hidden" />
            <input name="x_test_request" value={formData?.x_test_request} type="hidden" />
            <input name="x_type" value={formData?.x_type} type="hidden" />
            <input name="x_po_num" value={formData?.x_po_num} type="hidden" />
            <input name="x_receipt_link_method" value="AUTO-POST" type="hidden" />
            <input name="x_receipt_link_url" value={formData?.x_receipt_link_url} type="hidden" />
            <iframe
                id='ExactEmbeddedFrame'
                name='ExactEmbeddedFrame'
                title='ExactForm'
                style={{ width: '100%' }}
            />
        </Exact>
    )
}

// MONERIS ///////////////////////////////////////////////////////////////////////////////////////////////////////
const Moneris = styled.form`
    display: flex;
    flex-grow: 1;
    height: 600px;
    background: ${({ theme }) => theme.white};
`
export const MonerisDeprecated = ({ formData, socketId, ...props }) => {
    const {
        state: {
            mobile_view,
        },
    } = useGlobalState();

    useEffect(() => {
        if (!formData) return;
        document.getElementById('monerisHostedForm').submit();
    }, [formData])

    return (
        <Moneris action="https://esqa.moneris.com/HPPDP/index.php" method="post" target="MonerisEmbeddedFrame" id="monerisHostedForm">
            <input value={formData?.storeId} name="ps_store_id" type="hidden" />
            <input value={formData?.hppKey} name="hpp_key" type="hidden" />
            <input value={formData?.amount} name="charge_total" type="hidden" />
            <input value={formData?.refNum} name="order_id" type="hidden" />
            <input value={socketId} name="note" type="hidden" />
            <input value="True" name="rvar_test_account" type="hidden" />
            <iframe
                name="MonerisEmbeddedFrame"
                id="MonerisEmbeddedFrame"
                title='MonerisForm'
                style={{ width: mobile_view ? '100%' : '660px' }}
            />
        </Moneris>
    )
}

const MonerisNEW = styled.div`
    position: relative !important;
    display: flex !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
    flex-grow: 1;
    height: 600px !important;
    //width: 500px !important;
    background: ${({ theme }) => theme.white};
`
export const MonerisForm = ({ formData, socketId, ...props }) => {
    window.socketId = socketId;
    useLayoutEffect(() => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_MONERIS;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            const myCheckout = new window.monerisCheckout();
            myCheckout.setCheckoutDiv('monerisCheckout');
            myCheckout.setMode(formData.isTestAccount ? 'qa' : 'prod');
            myCheckout.setCallback('payment_receipt', (res) => {
                if (window.socketId !== socketId) return;
                res = JSON.parse(res);
                HamQuest.getQuery(QuestRoute.settings.monerisReceipt(formData.userId), {
                    ticket: res.ticket,
                    socketId: socketId
                })
                    .catch(ex => ModalFactory.catch(ex))
            });
            myCheckout.startCheckout(formData.ticket);
        };

        return () => {
            document.body.removeChild(script)
        };
    }, [])

    return <MonerisNEW id='monerisCheckout' />;
}

export const removeCardFromAccount = (loyaltyAccountId) => {
    return new Promise(async (resolve, reject) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Remove Card Info?`,
                body: (<span>Are you sure you want to remove the Card Info?</span>),
                type: 'warning',
            },
            promise: {
                title: 'Removing',
                body: `Removing, please wait.`,
                callback: () => HamQuest.delete(QuestRoute.user.loyaltyCreditCard(loyaltyAccountId))
            },
            confirmed: {
                title: 'Success',
                body: `Card Info removed.`,
                type: 'success'
            },
            finally: () => resolve()
        })
    })
}

export const addCardToAccount = (userId, updateState, amount) => {
    return new Promise(async (resolve, reject) => {
        let res = false;
        while (res !== true) {
            res = await tokenizeCard(userId, updateState, amount);
            if (res !== true) {
                const choice = await ModalFactory.confirmation({
                    title: 'An Error has occurred',
                    body: <div>{res}<br /><br />Would you like to try again?</div>,
                    type: 'error',
                    closeAfter: true,
                })

                if (!choice) {
                    reject(false)
                    return;
                }
            }
        }
        resolve(true)
    })
}

const tokenizeCard = (userId, updateState, amount) => {
    return new Promise((resolve, reject) => {
        const id = generateId();
        ModalFactory.promise({
            id,
            title: 'Building Payment Form',
            body: 'Please wait while we secure your connection.',
        })
        const socket = HamQuest.webSocket(process.env.REACT_APP_WS_URL);

        socket.error = e => {
            ModalFactory.update({
                id,
                title: 'Unable to Connect',
                body: 'Unable to add a card at this time, please try again later.',
                type: 'error',
            })
        };

        socket.ready = () => {
            ModalFactory.update({
                id,
                type: 'alert',
                title: 'Add a Card',
                icon: 'creditCard',
                body: <PaymentForm socketId={socket.id} userId={userId} amount={amount || 1} />,
                finally: () => socket.close(1000)
            })
        };

        socket.messaged = e => {
            socket.close(1000);
            try {
                if (e.success) {
                    if (updateState)
                        updateState(e.resultData);
                    resolve(true);
                } else {
                    resolve(e.errorMessage || 'An Error has occurred whilst adding your card.');
                }
                ModalFactory.close(id);
            }
            catch (e) {
                resolve({
                    errorMessage: e
                });
            }
        };
    })
}